<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div *ngFor="let field of displayableFields; last as last;">
      <borrower-attribute [field]="field" [form]="form" [disabled]="saving || !field.editable" [displayableInfo]="displayableInfo"></borrower-attribute>
      <div class="d-flex" *ngIf="hasEditableFields && last">
        <div *ngIf="success" class="alert alert-success small m-0 mr-3" [@fade]>
          <strong>Values saved successfully!</strong>
        </div>
        <div *ngIf="error != ''" class="alert alert-danger small m-0 mr-3" [@fade]>
          <strong>{{ error }}</strong>
        </div>
        <button mat-button type="submit" class="btn btn-primary ml-auto position-relative" [disabled]="!form.dirty || !form.valid || saving">
          <mat-spinner *ngIf="saving" class="spinner-btn position-absolute m-auto" [diameter]="25"></mat-spinner>
          <span [ngStyle]="{'opacity': saving ? 0 : 1}">Save</span>
        </button>
      </div>
    </div>
  </form>
</div>
